var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayCoachManagerRelation)?_c('span',{staticClass:"badge",style:(`background-color:${_vm.displayCoachManagerRelation.color}`)},[_vm._v(" "+_vm._s(_vm.displayCoachManagerRelation.pseudo)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }